import { render, staticRenderFns } from "./tags-text.vue?vue&type=template&id=af3aed74&scoped=true&"
import script from "./tags-text.vue?vue&type=script&lang=js&"
export * from "./tags-text.vue?vue&type=script&lang=js&"
import style0 from "./tags-text.vue?vue&type=style&index=0&id=af3aed74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3aed74",
  null
  
)

export default component.exports